var map = {
	"./angler.png": 661,
	"./baby_duck.png": 662,
	"./baby_jellyfish.png": 663,
	"./blob.png": 664,
	"./blue_bird.png": 665,
	"./boulder_dragon.png": 666,
	"./crab.png": 667,
	"./demon.png": 668,
	"./demon1.png": 669,
	"./dragon.png": 670,
	"./duck_thug.png": 671,
	"./hermit_king.png": 672,
	"./hermit_knight.png": 673,
	"./imp.png": 674,
	"./jellyboss.png": 675,
	"./liz_knight.png": 676,
	"./neckbeard.png": 677,
	"./ptero.png": 678,
	"./rocky.png": 679,
	"./snaketaur.png": 680,
	"./snow_mage.png": 681,
	"./spider.png": 682,
	"./worm.png": 683
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 295;